import * as React from "react";
import { useMemo } from "react";
import DocsHelper from "util/DocsHelper";
import useCurrentUser from "hooks/useCurrentUser";
import { isPermitted } from "util/PermissionsMixin";
import { DocumentTitle, PageHeader, Icon } from "components/common";
import { Row, Col, Button } from "components/bootstrap";
import { useModalContext } from "common/contexts";
import ProceduresList from "./EventProcedureList";
import StepsList from "./EventProcedureStepList";
const DESCRIPTION = /* @__PURE__ */ React.createElement("span", null, "Event Procedures provide a repeatable, guided structure for defining how your organization responds to security events. This feature enhances the process of remediation by introducing actionable steps that can be attached to event definitions, Sigma rules, and anomaly detectors.");
function SecurityUI({ viewType }) {
  const { setModal } = useModalContext();
  const openEventProcedureModal = () => {
    setModal("CREATE-EVENT-PROCEDURE");
  };
  const openEventProcedureStepModal = () => {
    setModal("CREATE-EVENT-PROCEDURE-STEP");
  };
  const { permissions } = useCurrentUser();
  const canCreateEventProcedures = useMemo(() => isPermitted(permissions, "event_procedures:create"), [permissions]);
  const canCreateEventProcedureSteps = useMemo(
    () => isPermitted(permissions, "event_procedure_steps:create"),
    [permissions]
  );
  return /* @__PURE__ */ React.createElement(DocumentTitle, { title: viewType === "procedures" ? "Event Procedures" : "Event Procedure Steps" }, viewType === "procedures" ? /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: "Event Procedures",
      documentationLink: {
        title: "Event Procedures Documentation",
        path: DocsHelper.PAGES.EVENT_PROCEDURES
      },
      actions: canCreateEventProcedures && /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", onClick: () => openEventProcedureModal() }, /* @__PURE__ */ React.createElement(Icon, { name: "add", size: "xs" }), "Create Event Procedure")
    },
    /* @__PURE__ */ React.createElement("span", null, DESCRIPTION)
  ) : /* @__PURE__ */ React.createElement(
    PageHeader,
    {
      title: "Event Procedure Steps",
      documentationLink: {
        title: "Event Procedures Documentation",
        path: DocsHelper.PAGES.EVENT_PROCEDURES
      },
      actions: canCreateEventProcedureSteps && /* @__PURE__ */ React.createElement(Button, { bsStyle: "primary", onClick: () => openEventProcedureStepModal() }, /* @__PURE__ */ React.createElement(Icon, { name: "add", size: "xs" }), "Create Event Procedure Step")
    },
    /* @__PURE__ */ React.createElement("span", null, DESCRIPTION)
  ), /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, viewType === "procedures" ? /* @__PURE__ */ React.createElement(ProceduresList, null) : /* @__PURE__ */ React.createElement(StepsList, null))));
}
export default SecurityUI;
